import { Button } from '@/components/ui/Button';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { navigate } from 'gatsby';
import React from 'react';
import { toggleModal } from '../../../app/redux/actions/globalModalAction';
import { setUserprofileCompletionState } from '../../../app/redux/actions/userProfileCompletionActions';
import { useAppDispatch } from '../../../app/redux/hooks';

const CompletionScreen = () => {
  const dispatch = useAppDispatch();

  const handleClose = (redirect: string) => {
    dispatch(setUserprofileCompletionState(false));
    dispatch(toggleModal(false));
    navigate(redirect);
  };

  return (
    <div className="text-center">
      <h2 className="md:display-title-3xl display-title-xl mt-8">Nice one. You’re at 100%</h2>
      <div className="inline-block uppercase bg-gray-200 mb-4 md:mt-10 mt-5 px-3 py-1 rounded-lg space-x-1.5 text-xxs font-semibold">
        what does that mean?
      </div>
      <div className="flex-row px-10 md:mb-10 mb-5 text-sm text-left gap-3">
        <div className="flex items-center p-2">
          <FontAwesomeIcon icon={['fas', 'check-circle']} className=" mr-2 text-success-700" size="lg" />
          You’ve maximised your profile visibility to potential employers.
        </div>
        <div className="flex items-start p-2">
          <FontAwesomeIcon icon={['fas', 'check-circle']} className="mr-2 text-success-700" size={'lg'} />
          We’ll be able to recommend jobs, articles, events, and employers that are more relevant to you.
        </div>
      </div>

      <div className="flex flex-col gap-3 w-full">
        <Button aria-label="View my feed" className="w-full" onClick={() => handleClose('/dashboard')}>
          View my tailored feed
        </Button>
        <Button
          aria-label="View my profile"
          appearance="primary"
          variant="outline"
          className="w-full"
          onClick={() => handleClose('/dashboard/profile')}
        >
          Review and make changes
        </Button>
      </div>
    </div>
  );
};

export default CompletionScreen;
